import styles from "./styles.module.css";

export default function Spinner() {
  return <div className={styles.spinner} />;
}
